import { CLEAR_ALARMS } from '../constants'

export default () => (dispatch, getState) => {
    dispatch({ type: CLEAR_ALARMS })

    const subscription = getState().dashboardReducer.subscription

    if (subscription && Array.isArray(subscription)) {
        subscription.forEach(s => window.cometd.unsubscribe(s))
    }
}
